import { IStoreApiItem, StoreApiItem } from '@/common/interfaces/store-api-item.interface'
import { IStoreApiList, StoreApiList } from '@/common/interfaces/store-api-list.interface'

import { ILeaseDealBundle, ILeaseDealTemplate } from '@/features/promotions/interfaces/lease-deal-templates.interfaces'
import {
  IGeneratePromotion,
  IPromotion,
  IPromotionConfigData,
} from '@/features/promotions/interfaces/promotions.interfaces'

export interface IPromotionsState {
  promotions: IStoreApiList<IPromotion[]>
  configData: IStoreApiItem<IPromotionConfigData>
  promotion: IStoreApiItem<IPromotion>
  generatedPromotion: IStoreApiItem<IGeneratePromotion>
  leaseDealTemplates: IStoreApiItem<ILeaseDealTemplate[]>
  leaseDealBundles: IStoreApiItem<ILeaseDealBundle[]>
}

export class PromotionsState implements IPromotionsState {
  promotions: IStoreApiList<IPromotion[]> = new StoreApiList<IPromotion[]>()
  configData: IStoreApiItem<IPromotionConfigData> = new StoreApiItem<IPromotionConfigData>()
  promotion: IStoreApiItem<IPromotion> = new StoreApiItem<IPromotion>()
  generatedPromotion: IStoreApiItem<IGeneratePromotion> = new StoreApiItem<IGeneratePromotion>()
  leaseDealTemplates: IStoreApiItem<ILeaseDealTemplate[]> = new StoreApiItem<ILeaseDealTemplate[]>()
  leaseDealBundles: IStoreApiItem<ILeaseDealBundle[]> = new StoreApiItem<ILeaseDealBundle[]>()
}
